'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var _lodash = require('lodash');

var _lodash2 = _interopRequireDefault(_lodash);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

//core text

var _widgetsTextRenderer = require('./widgets/TextRenderer');

var _widgetsTextRenderer2 = _interopRequireDefault(_widgetsTextRenderer);

var _widgetsRichTextRenderer = require('./widgets/RichTextRenderer');

var _widgetsRichTextRenderer2 = _interopRequireDefault(_widgetsRichTextRenderer);

var _widgetsJsxRenderer = require('./widgets/JsxRenderer');

var _widgetsJsxRenderer2 = _interopRequireDefault(_widgetsJsxRenderer);

var _widgetsHtmlContent = require('./widgets/HtmlContent');

var _widgetsHtmlContent2 = _interopRequireDefault(_widgetsHtmlContent);

var _widgetsArticleContent = require('./widgets/ArticleContent');

var _widgetsArticleContent2 = _interopRequireDefault(_widgetsArticleContent);

var _widgetsListItemContent = require('./widgets/ListItemContent');

var _widgetsListItemContent2 = _interopRequireDefault(_widgetsListItemContent);

//core boxes

var _widgetsBackgroundBox = require('./widgets/BackgroundBox');

var _widgetsBackgroundBox2 = _interopRequireDefault(_widgetsBackgroundBox);

var _widgetsHtmlBox = require('./widgets/HtmlBox');

var _widgetsHtmlBox2 = _interopRequireDefault(_widgetsHtmlBox);

var _widgetsHtmlImageBox = require('./widgets/HtmlImageBox');

var _widgetsHtmlImageBox2 = _interopRequireDefault(_widgetsHtmlImageBox);

//core image

var _widgetsImageBox = require('./widgets/ImageBox');

var _widgetsImageBox2 = _interopRequireDefault(_widgetsImageBox);

var _widgetsSmartImageBox = require('./widgets/SmartImageBox');

var _widgetsSmartImageBox2 = _interopRequireDefault(_widgetsSmartImageBox);

var _widgetsATvImageBox = require('./widgets/ATvImageBox');

var _widgetsATvImageBox2 = _interopRequireDefault(_widgetsATvImageBox);

//flex box

var _widgetsImageFlexBox = require('./widgets/ImageFlexBox');

var _widgetsImageFlexBox2 = _interopRequireDefault(_widgetsImageFlexBox);

//text box input

var _widgetsTextBoxInput = require('./widgets/TextBoxInput');

var _widgetsTextBoxInput2 = _interopRequireDefault(_widgetsTextBoxInput);

var _widgetsIcon = require('./widgets/Icon');

var _widgetsIcon2 = _interopRequireDefault(_widgetsIcon);

var _widgetsIconMorphTransition = require('./widgets/IconMorphTransition');

var _widgetsIconMorphTransition2 = _interopRequireDefault(_widgetsIconMorphTransition);

exports['default'] = {

	"TextContent": _widgetsTextRenderer2['default'],
	"RichTextContent": _widgetsRichTextRenderer2['default'],
	"HtmlContent": _widgetsHtmlContent2['default'],
	"JsxContent": _widgetsJsxRenderer2['default'],
	"ArticleContent": _widgetsArticleContent2['default'],
	"ListItemContent": _widgetsListItemContent2['default'],

	"ImageBox": _widgetsImageBox2['default'],
	"SmartImageBox": _widgetsSmartImageBox2['default'],
	"ATvImageBox": _widgetsATvImageBox2['default'],

	"BackgroundBox": _widgetsBackgroundBox2['default'],
	"HtmlBox": _widgetsHtmlBox2['default'],
	"HtmlImageBox": _widgetsHtmlImageBox2['default'],

	"ImageFlexBox": _widgetsImageFlexBox2['default'],

	"TextBoxInput": _widgetsTextBoxInput2['default'],
	"Icon": _widgetsIcon2['default'],
	"IconMorph": _widgetsIconMorphTransition2['default'],
	//deprecated name
	"IconMorphTransition": _widgetsIconMorphTransition2['default']
};
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./~/react-photo-widget-factory/lib/PhotoWidgetFactory.js
 ** module id = 2213
 ** module chunks = 0
 **/